import { lazy } from 'react';

const admActorsIntegrativePageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: true,
					style: 'static'
				},
			}
		}
	},
	routes: [
		{
			path: '/integrative/config/actors',
			component: lazy(() => import('./AdmCompaniesPage'))
		}
	]
};

export default admActorsIntegrativePageConfig;
